import { Component, effect, inject, signal, untracked } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NetworkService } from '../../services/network.service';

const BACK_ONLINE_MS = 3000;

@Component({
  selector: 'urban-offline-banner',
  imports: [TranslateModule],
  templateUrl: './offline-banner.component.html',
  styleUrl: './offline-banner.component.scss',
})
export class OfflineBannerComponent {
  private readonly network = inject(NetworkService);
  private wasOffline: boolean = false;
  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  readonly state = signal<'offline' | 'back' | null>(null);
  /** The offline page covers the screen and says it already. */
  readonly blocking = this.network.blocking;

  constructor() {
    effect(() => {
      const offline: boolean = this.network.offline();
      untracked(() => this.onOfflineChange(offline));
    });
  }

  private onOfflineChange(offline: boolean): void {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }

    if (offline) {
      this.wasOffline = true;
      this.state.set('offline');
      return;
    }

    if (!this.wasOffline) {
      return;
    }
    this.wasOffline = false;
    this.state.set('back');
    this.hideTimer = setTimeout(() => this.state.set(null), BACK_ONLINE_MS);
  }
}
